module.exports = __webpack_public_path__ + "fonts/Retro Team.9fcd4f85.otf";